export const ShiyuAll = [
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 13.81,
    rank: 1,
    avg_round: 105,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'astra-yao',
    app_rate: 13.12,
    rank: 2,
    avg_round: 98,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lycaon',
    char_three: 'soukaku',
    app_rate: 10.26,
    rank: 3,
    avg_round: 122,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'qingyi',
    char_three: 'nicole-demara',
    app_rate: 8.25,
    rank: 4,
    avg_round: 147,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'burnice',
    char_three: 'lucy',
    app_rate: 8.07,
    rank: 5,
    avg_round: 108,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 7.08,
    rank: 6,
    avg_round: 95,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'rina',
    app_rate: 6.67,
    rank: 7,
    avg_round: 112,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'trigger',
    char_three: 'caesar',
    app_rate: 6.34,
    rank: 8,
    avg_round: 132,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'burnice',
    char_three: 'astra-yao',
    app_rate: 5.6,
    rank: 9,
    avg_round: 97,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'caesar',
    app_rate: 4.74,
    rank: 10,
    avg_round: 117,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'qingyi',
    char_three: 'rina',
    app_rate: 3.74,
    rank: 11,
    avg_round: 149,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'qingyi',
    char_three: 'astra-yao',
    app_rate: 3.57,
    rank: 12,
    avg_round: 128,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'qingyi',
    char_three: 'nicole-demara',
    app_rate: 3.26,
    rank: 13,
    avg_round: 127,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lighter',
    char_three: 'lucy',
    app_rate: 3.06,
    rank: 14,
    avg_round: 112,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'trigger',
    char_three: 'nicole-demara',
    app_rate: 2.95,
    rank: 15,
    avg_round: 116,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'soukaku',
    app_rate: 2.88,
    rank: 16,
    avg_round: 122,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lycaon',
    char_three: 'astra-yao',
    app_rate: 2.7,
    rank: 17,
    avg_round: 101,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'trigger',
    char_three: 'rina',
    app_rate: 2.7,
    rank: 17,
    avg_round: 135,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'lighter',
    char_three: 'astra-yao',
    app_rate: 2.7,
    rank: 17,
    avg_round: 113,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'trigger',
    char_three: 'pulchra',
    app_rate: 2.6,
    rank: 20,
    avg_round: 156,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'pulchra',
    char_three: 'astra-yao',
    app_rate: 2.47,
    rank: 21,
    avg_round: 144,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'trigger',
    char_three: 'rina',
    app_rate: 1.96,
    rank: 22,
    avg_round: 118,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'soukaku',
    char_three: 'astra-yao',
    app_rate: 1.76,
    rank: 23,
    avg_round: 111,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'koleda',
    char_three: 'astra-yao',
    app_rate: 1.76,
    rank: 23,
    avg_round: 154,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'astra-yao',
    char_three: 'caesar',
    app_rate: 1.66,
    rank: 25,
    avg_round: 109,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'qingyi',
    char_three: 'astra-yao',
    app_rate: 1.58,
    rank: 26,
    avg_round: 151,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'qingyi',
    char_three: 'astra-yao',
    app_rate: 1.5,
    rank: 27,
    avg_round: 131,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 1.43,
    rank: 28,
    avg_round: 118,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 1.43,
    rank: 28,
    avg_round: 125,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 1.35,
    rank: 30,
    avg_round: 123,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'rina',
    char_three: 'caesar',
    app_rate: 1.3,
    rank: 31,
    avg_round: 130,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'trigger',
    char_three: 'qingyi',
    app_rate: 1.2,
    rank: 32,
    avg_round: 151,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'burnice',
    char_three: 'soukaku',
    app_rate: 1.2,
    rank: 32,
    avg_round: 127,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 1.17,
    rank: 34,
    avg_round: 129,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'nicole-demara',
    app_rate: 1.15,
    rank: 35,
    avg_round: 115,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'pulchra',
    char_three: 'caesar',
    app_rate: 1.15,
    rank: 35,
    avg_round: 165,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'seth',
    char_three: 'rina',
    app_rate: 1.12,
    rank: 37,
    avg_round: 142,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'burnice',
    app_rate: 1.07,
    rank: 38,
    avg_round: 118,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lycaon',
    char_three: 'astra-yao',
    app_rate: 1.07,
    rank: 38,
    avg_round: 165,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'lucy',
    app_rate: 1.02,
    rank: 40,
    avg_round: 111,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 0.99,
    rank: 41,
    avg_round: 104,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'trigger',
    app_rate: 0.99,
    rank: 41,
    avg_round: 115,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'astra-yao',
    char_three: 'caesar',
    app_rate: 0.97,
    rank: 43,
    avg_round: 142,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lycaon',
    char_three: 'soukaku',
    app_rate: 0.94,
    rank: 44,
    avg_round: 194,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'piper',
    char_three: 'lucy',
    app_rate: 0.92,
    rank: 45,
    avg_round: 116,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'soukaku',
    char_three: 'caesar',
    app_rate: 0.89,
    rank: 46,
    avg_round: 146,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'burnice',
    char_three: 'rina',
    app_rate: 0.87,
    rank: 47,
    avg_round: 136,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 0.84,
    rank: 48,
    avg_round: 136,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lycaon',
    char_three: 'caesar',
    app_rate: 0.82,
    rank: 49,
    avg_round: 176,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'qingyi',
    char_three: 'rina',
    app_rate: 0.76,
    rank: 50,
    avg_round: 160,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'burnice',
    char_three: 'caesar',
    app_rate: 0.76,
    rank: 50,
    avg_round: 149,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'soukaku',
    char_three: 'nicole-demara',
    app_rate: 0.76,
    rank: 50,
    avg_round: 128,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'trigger',
    char_three: 'rina',
    app_rate: 0.71,
    rank: 53,
    avg_round: 162,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'qingyi',
    char_three: 'caesar',
    app_rate: 0.71,
    rank: 53,
    avg_round: 154,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'burnice',
    char_three: 'nicole-demara',
    app_rate: 0.69,
    rank: 55,
    avg_round: 110,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'evelyn',
    char_three: 'astra-yao',
    app_rate: 0.66,
    rank: 56,
    avg_round: 117,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lycaon',
    char_three: 'nicole-demara',
    app_rate: 0.66,
    rank: 56,
    avg_round: 125,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'burnice',
    char_three: 'astra-yao',
    app_rate: 0.66,
    rank: 56,
    avg_round: 107,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'grace-howard',
    char_three: 'rina',
    app_rate: 0.64,
    rank: 59,
    avg_round: 128,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lucy',
    char_three: 'caesar',
    app_rate: 0.64,
    rank: 59,
    avg_round: 124,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'pulchra',
    char_three: 'rina',
    app_rate: 0.61,
    rank: 61,
    avg_round: 170,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'nicole-demara',
    char_three: 'caesar',
    app_rate: 0.61,
    rank: 61,
    avg_round: 112,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'anby-demara',
    char_three: 'astra-yao',
    app_rate: 0.61,
    rank: 61,
    avg_round: 156,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'rina',
    char_three: 'astra-yao',
    app_rate: 0.61,
    rank: 61,
    avg_round: 106,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'burnice',
    char_three: 'lucy',
    app_rate: 0.61,
    rank: 61,
    avg_round: 148,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'trigger',
    char_three: 'caesar',
    app_rate: 0.61,
    rank: 61,
    avg_round: 137,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'anby-demara',
    char_three: 'nicole-demara',
    app_rate: 0.61,
    rank: 61,
    avg_round: 172,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'anby-demara',
    char_three: 'nicole-demara',
    app_rate: 0.59,
    rank: 68,
    avg_round: 180,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'qingyi',
    char_three: 'nicole-demara',
    app_rate: 0.59,
    rank: 68,
    avg_round: 152,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'astra-yao',
    char_three: 'caesar',
    app_rate: 0.59,
    rank: 68,
    avg_round: 125,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'trigger',
    char_three: 'lucy',
    app_rate: 0.56,
    rank: 71,
    avg_round: 131,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'trigger',
    char_three: 'nicole-demara',
    app_rate: 0.53,
    rank: 72,
    avg_round: 148,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'qingyi',
    char_three: 'astra-yao',
    app_rate: 0.51,
    rank: 73,
    avg_round: 130,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'anby-demara',
    char_three: 'rina',
    app_rate: 0.48,
    rank: 74,
    avg_round: 205,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'seth',
    char_three: 'astra-yao',
    app_rate: 0.46,
    rank: 75,
    avg_round: 201,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'burnice',
    char_three: 'trigger',
    app_rate: 0.46,
    rank: 75,
    avg_round: 141,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 0.43,
    rank: 77,
    avg_round: 95,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'burnice',
    char_three: 'caesar',
    app_rate: 0.43,
    rank: 77,
    avg_round: 160,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'trigger',
    char_three: 'nicole-demara',
    app_rate: 0.43,
    rank: 77,
    avg_round: 152,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'pulchra',
    char_three: 'nicole-demara',
    app_rate: 0.43,
    rank: 77,
    avg_round: 175,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'yanagi',
    char_three: 'trigger',
    app_rate: 0.43,
    rank: 77,
    avg_round: 180,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 0.41,
    rank: 82,
    avg_round: 100,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'nicole-demara',
    char_three: 'caesar',
    app_rate: 0.41,
    rank: 82,
    avg_round: 141,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'yanagi',
    char_three: 'astra-yao',
    app_rate: 0.38,
    rank: 84,
    avg_round: 137,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'pulchra',
    char_three: 'lucy',
    app_rate: 0.38,
    rank: 84,
    avg_round: 181,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'burnice',
    char_three: 'caesar',
    app_rate: 0.38,
    rank: 84,
    avg_round: 247,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'burnice',
    char_three: 'astra-yao',
    app_rate: 0.38,
    rank: 84,
    avg_round: 150,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 0.38,
    rank: 84,
    avg_round: 147,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'lycaon',
    app_rate: 0.36,
    rank: 89,
    avg_round: 125,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lucy',
    char_three: 'astra-yao',
    app_rate: 0.33,
    rank: 90,
    avg_round: 115,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lycaon',
    char_three: 'lighter',
    app_rate: 0.33,
    rank: 90,
    avg_round: 190,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'nicole-demara',
    char_three: 'lucy',
    app_rate: 0.31,
    rank: 92,
    avg_round: 115,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'trigger',
    char_three: 'qingyi',
    app_rate: 0.31,
    rank: 92,
    avg_round: 155,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'trigger',
    char_three: 'rina',
    app_rate: 0.31,
    rank: 92,
    avg_round: 116,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'seth',
    char_three: 'caesar',
    app_rate: 0.31,
    rank: 92,
    avg_round: 239,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'qingyi',
    char_three: 'rina',
    app_rate: 0.31,
    rank: 92,
    avg_round: 147,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'trigger',
    char_three: 'soukaku',
    app_rate: 0.28,
    rank: 97,
    avg_round: 121,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'trigger',
    char_three: 'nicole-demara',
    app_rate: 0.28,
    rank: 97,
    avg_round: 110,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'soukaku',
    char_three: 'caesar',
    app_rate: 0.28,
    rank: 97,
    avg_round: 194,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'lighter',
    char_three: 'lucy',
    app_rate: 0.28,
    rank: 97,
    avg_round: 141,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'qingyi',
    char_three: 'pulchra',
    app_rate: 0.28,
    rank: 97,
    avg_round: 184,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'lucy',
    char_three: 'astra-yao',
    app_rate: 0.25,
    rank: 102,
    avg_round: 155,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'burnice',
    char_three: 'lucy',
    app_rate: 0.25,
    rank: 102,
    avg_round: 192,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'trigger',
    char_three: 'caesar',
    app_rate: 0.25,
    rank: 102,
    avg_round: 168,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'jane-doe',
    char_three: 'rina',
    app_rate: 0.25,
    rank: 102,
    avg_round: 142,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lighter',
    char_three: 'astra-yao',
    app_rate: 0.25,
    rank: 102,
    avg_round: 126,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'piper',
    char_three: 'astra-yao',
    app_rate: 0.25,
    rank: 102,
    avg_round: 107,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'jane-doe',
    char_three: 'astra-yao',
    app_rate: 0.25,
    rank: 102,
    avg_round: 117,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'qingyi',
    char_three: 'caesar',
    app_rate: 0.25,
    rank: 102,
    avg_round: 143,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'yanagi',
    char_three: 'astra-yao',
    app_rate: 0.25,
    rank: 102,
    avg_round: 147,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'miyabi',
    char_three: 'astra-yao',
    app_rate: 0.23,
    rank: 111,
    avg_round: 128,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'trigger',
    char_three: 'seth',
    app_rate: 0.23,
    rank: 111,
    avg_round: 155,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'grace-howard',
    char_three: 'soukaku',
    app_rate: 0.23,
    rank: 111,
    avg_round: 120,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'jane-doe',
    char_three: 'astra-yao',
    app_rate: 0.23,
    rank: 111,
    avg_round: 115,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'rina',
    char_three: 'caesar',
    app_rate: 0.2,
    rank: 115,
    avg_round: 156,
    star_num: '4'
  },
  {
    char_one: 'piper',
    char_two: 'burnice',
    char_three: 'lucy',
    app_rate: 0.2,
    rank: 115,
    avg_round: 188,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lighter',
    char_three: 'astra-yao',
    app_rate: 0.2,
    rank: 115,
    avg_round: 152,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'trigger',
    char_three: 'qingyi',
    app_rate: 0.2,
    rank: 115,
    avg_round: 214,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'grace-howard',
    char_three: 'astra-yao',
    app_rate: 0.2,
    rank: 115,
    avg_round: 108,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'koleda',
    char_three: 'lucy',
    app_rate: 0.18,
    rank: 120,
    avg_round: 180,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'grace-howard',
    char_three: 'astra-yao',
    app_rate: 0.18,
    rank: 120,
    avg_round: 167,
    star_num: '4'
  },
  {
    char_one: 'corin',
    char_two: 'qingyi',
    char_three: 'rina',
    app_rate: 0.18,
    rank: 120,
    avg_round: 170,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'rina',
    char_three: 'astra-yao',
    app_rate: 0.18,
    rank: 120,
    avg_round: 120,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'qingyi',
    char_three: 'astra-yao',
    app_rate: 0.18,
    rank: 120,
    avg_round: 144,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'yanagi',
    char_three: 'rina',
    app_rate: 0.15,
    rank: 126,
    avg_round: 180,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'soukaku',
    char_three: 'lucy',
    app_rate: 0.15,
    rank: 126,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'trigger',
    char_three: 'lucy',
    app_rate: 0.15,
    rank: 126,
    avg_round: 139,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lighter',
    char_three: 'soukaku',
    app_rate: 0.15,
    rank: 126,
    avg_round: 181,
    star_num: '4'
  },
  {
    char_one: 'piper',
    char_two: 'burnice',
    char_three: 'astra-yao',
    app_rate: 0.15,
    rank: 126,
    avg_round: 159,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'rina',
    char_three: 'astra-yao',
    app_rate: 0.15,
    rank: 126,
    avg_round: 127,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'miyabi',
    char_three: 'nicole-demara',
    app_rate: 0.15,
    rank: 126,
    avg_round: 138,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'burnice',
    char_three: 'rina',
    app_rate: 0.15,
    rank: 126,
    avg_round: 134,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'yanagi',
    char_three: 'rina',
    app_rate: 0.15,
    rank: 126,
    avg_round: 183,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'yanagi',
    char_three: 'qingyi',
    app_rate: 0.13,
    rank: 136,
    avg_round: 188,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'yanagi',
    char_three: 'trigger',
    app_rate: 0.13,
    rank: 136,
    avg_round: 169,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'burnice',
    char_three: 'seth',
    app_rate: 0.13,
    rank: 136,
    avg_round: 154,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'rina',
    char_three: 'caesar',
    app_rate: 0.13,
    rank: 136,
    avg_round: 139,
    star_num: '4'
  },
  {
    char_one: 'nekomata',
    char_two: 'qingyi',
    char_three: 'nicole-demara',
    app_rate: 0.13,
    rank: 136,
    avg_round: 147,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'qingyi',
    char_three: 'rina',
    app_rate: 0.13,
    rank: 136,
    avg_round: 142,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lycaon',
    char_three: 'rina',
    app_rate: 0.13,
    rank: 136,
    avg_round: 154,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'jane-doe',
    char_three: 'seth',
    app_rate: 0.13,
    rank: 136,
    avg_round: 161,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'qingyi',
    char_three: 'soukaku',
    app_rate: 0.13,
    rank: 136,
    avg_round: 217,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'jane-doe',
    char_three: 'caesar',
    app_rate: 0.13,
    rank: 136,
    avg_round: 150,
    star_num: '4'
  },
  {
    char_one: 'piper',
    char_two: 'burnice',
    char_three: 'caesar',
    app_rate: 0.1,
    rank: 150,
    avg_round: 225,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'anby-demara',
    char_three: 'nicole-demara',
    app_rate: 0.1,
    rank: 150,
    avg_round: 175,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'lucy',
    char_three: 'caesar',
    app_rate: 0.1,
    rank: 150,
    avg_round: 203,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'qingyi',
    char_three: 'astra-yao',
    app_rate: 0.1,
    rank: 150,
    avg_round: 134,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'lycaon',
    char_three: 'nicole-demara',
    app_rate: 0.1,
    rank: 150,
    avg_round: 160,
    star_num: '4'
  },
  {
    char_one: 'billy-kid',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 0.1,
    rank: 150,
    avg_round: 110,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'jane-doe',
    char_three: 'trigger',
    app_rate: 0.1,
    rank: 150,
    avg_round: 151,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'qingyi',
    char_three: 'lucy',
    app_rate: 0.1,
    rank: 150,
    avg_round: 200,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'lucy',
    char_three: 'caesar',
    app_rate: 0.1,
    rank: 150,
    avg_round: 209,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'seth',
    char_three: 'lucy',
    app_rate: 0.1,
    rank: 150,
    avg_round: 155,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'rina',
    char_three: 'nicole-demara',
    app_rate: 0.1,
    rank: 150,
    avg_round: 110,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'qingyi',
    char_three: 'soukaku',
    app_rate: 0.1,
    rank: 150,
    avg_round: 191,
    star_num: '4'
  },
  {
    char_one: 'anton',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 0.1,
    rank: 150,
    avg_round: 158,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'qingyi',
    char_three: 'caesar',
    app_rate: 0.1,
    rank: 150,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'burnice',
    char_three: 'astra-yao',
    app_rate: 0.1,
    rank: 150,
    avg_round: 143,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'yanagi',
    char_three: 'qingyi',
    app_rate: 0.1,
    rank: 150,
    avg_round: 177,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'trigger',
    char_three: 'caesar',
    app_rate: 0.1,
    rank: 150,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'soukaku',
    char_three: 'astra-yao',
    app_rate: 0.1,
    rank: 150,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'anby-demara',
    char_three: 'soukaku',
    app_rate: 0.1,
    rank: 150,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'soldier-11',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 0.08,
    rank: 180,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'trigger',
    char_two: 'qingyi',
    char_three: 'astra-yao',
    app_rate: 0.08,
    rank: 180,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'lycaon',
    char_three: 'astra-yao',
    app_rate: 0.08,
    rank: 180,
    avg_round: 209,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lighter',
    char_three: 'rina',
    app_rate: 0.08,
    rank: 180,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'anby-demara',
    char_three: 'caesar',
    app_rate: 0.08,
    rank: 180,
    avg_round: 171,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'anby-demara',
    char_three: 'nicole-demara',
    app_rate: 0.08,
    rank: 180,
    avg_round: 119,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'grace-howard',
    char_three: 'rina',
    app_rate: 0.08,
    rank: 180,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'seth',
    char_three: 'astra-yao',
    app_rate: 0.08,
    rank: 180,
    avg_round: 139,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'anby-demara',
    char_three: 'astra-yao',
    app_rate: 0.08,
    rank: 180,
    avg_round: 154,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'trigger',
    char_three: 'qingyi',
    app_rate: 0.08,
    rank: 180,
    avg_round: 147,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'nicole-demara',
    char_three: 'caesar',
    app_rate: 0.08,
    rank: 180,
    avg_round: 174,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'rina',
    char_three: 'nicole-demara',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'qingyi',
    char_three: 'caesar',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'grace-howard',
    char_three: 'trigger',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'burnice',
    char_three: 'qingyi',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'seth',
    char_three: 'nicole-demara',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'grace-howard',
    char_three: 'rina',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'rina',
    char_three: 'lucy',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lighter',
    char_three: 'caesar',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'ellen',
    char_three: 'soukaku',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'anby-demara',
    char_three: 'nicole-demara',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'lycaon',
    char_three: 'astra-yao',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'koleda',
    char_three: 'nicole-demara',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'anby-demara',
    char_three: 'rina',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'miyabi',
    char_three: 'soukaku',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'lighter',
    char_three: 'nicole-demara',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'lycaon',
    char_three: 'nicole-demara',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'harumasa',
    char_three: 'nicole-demara',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'grace-howard',
    char_three: 'seth',
    app_rate: 0.05,
    rank: 204,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'corin',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'anton',
    char_two: 'rina',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'anby-demara',
    char_three: 'soukaku',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'pulchra',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'trigger',
    char_three: 'koleda',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'koleda',
    char_three: 'soukaku',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'lighter',
    char_two: 'astra-yao',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'burnice',
    char_two: 'grace-howard',
    char_three: 'qingyi',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'yanagi',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'jane-doe',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'trigger',
    char_two: 'qingyi',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'ellen',
    char_three: 'lighter',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'anton',
    char_two: 'qingyi',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'piper',
    char_two: 'grace-howard',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'astra-yao',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'corin',
    char_two: 'jane-doe',
    char_three: 'seth',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'lycaon',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'pulchra',
    char_three: 'lucy',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'trigger',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'qingyi',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'qingyi',
    char_three: 'seth',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'koleda',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'burnice',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'jane-doe',
    char_three: 'qingyi',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'soukaku',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'piper',
    char_two: 'lucy',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'nekomata',
    char_two: 'nicole-demara',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'lighter',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'nicole-demara',
    char_three: 'lucy',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'miyabi',
    char_three: 'lucy',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'burnice',
    char_three: 'koleda',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'rina',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'anby-demara',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'rina',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'pulchra',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'yanagi',
    char_three: 'piper',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'seth',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'jane-doe',
    char_two: 'burnice',
    char_three: 'pulchra',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'ellen',
    char_two: 'rina',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'grace-howard',
    char_two: 'trigger',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'soldier-11',
    char_two: 'miyabi',
    char_three: 'lucy',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'harumasa',
    char_two: 'pulchra',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'lycaon',
    char_two: 'lighter',
    char_three: 'soukaku',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'burnice',
    char_three: 'pulchra',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'burnice',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'zhu-yuan',
    char_two: 'lighter',
    char_three: 'astra-yao',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'burnice',
    char_three: 'trigger',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'evelyn',
    char_three: 'burnice',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'soukaku',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'qingyi',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'harumasa',
    char_three: 'qingyi',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'piper',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'grace-howard',
    char_two: 'trigger',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'yanagi',
    char_two: 'jane-doe',
    char_three: 'anby-demara',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'evelyn',
    char_three: 'soukaku',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'seth',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'miyabi',
    char_three: 'soukaku',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'piper',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'corin',
    char_two: 'piper',
    char_three: 'qingyi',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'burnice',
    char_three: 'qingyi',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'anby-demara-soldier-0',
    char_two: 'qingyi',
    char_three: 'anby-demara',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'miyabi',
    char_two: 'piper',
    char_three: 'soukaku',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'soldier-11',
    char_two: 'trigger',
    char_three: 'caesar',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'evelyn',
    char_two: 'pulchra',
    char_three: 'lighter',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  },
  {
    char_one: 'burnice',
    char_two: 'grace-howard',
    char_three: 'rina',
    app_rate: 0.03,
    rank: 285,
    avg_round: 600,
    star_num: '4'
  }
];
